import React from "react";
import { Row, Col, Divider } from "antd";
import IntlMessages from "../../../util/IntlMessages";
import { formatDigits, parseFloatCustom } from "../../../appRedux/actions";
import moment from "moment";
// import { PlayCircleFilled } from "@ant-design/icons";

export class PrintLastSummary extends React.PureComponent {
  // state = {
  //   data: this.props.data ? this.props.data : false,
  // };
  render() {
    const data = this.props.data ? this.props.data : false;
    const decimal = this.props.decimal ? this.props.decimal : 2;
    const dataLastSummary = this.props.dataLastSummary
      ? this.props.dataLastSummary
      : false;
    var totalExpected = 0;
    let cashToBank = 0;
    const openingFloat =
      data &&
      data.registerInOut &&
      data.registerInOut.filter((a) => a.reason == "OF").length > 0
        ? data.registerInOut.filter((a) => a.cashManageID != "")[0].amount
        : 0;
    const counted =
      data && data.outletRegister && data.outletRegister.counted
        ? data.outletRegister.counted
        : 0;
    const currData = this.props.currData
      ? this.props.currData
      : { currencyCode: "" };
    cashToBank = counted - openingFloat;
    cashToBank = cashToBank.toString();

    if (dataLastSummary && dataLastSummary.length > 0) {
      dataLastSummary.map((e) => {
        if (e.isPrimary) {
          totalExpected =
            data && data.outletRegister && data.outletRegister.expected
              ? parseFloatCustom(data.outletRegister.expected + e.expected)
              : 0;
        } else {
          if (e.paymentTypes != "Loyalty") {
            totalExpected = parseFloatCustom(totalExpected + e.expected);
          }
        }
      });
    }
    const today = moment().format('LLLL');
    // const objToday = new Date(),
    //   weekday = new Array(
    //     "Sunday",
    //     "Monday",
    //     "Tuesday",
    //     "Wednesday",
    //     "Thursday",
    //     "Friday",
    //     "Saturday"
    //   ),
    //   dayOfWeek = weekday[objToday.getDay()],
    //   domEnder = (function () {
    //     var a = objToday;
    //     if (/1/.test(parseInt((a + "").charAt(0)))) return "th";
    //     a = parseInt((a + "").charAt(1));
    //     return 1 == a ? "st" : 2 == a ? "nd" : 3 == a ? "rd" : "th";
    //   })(),
    //   dayOfMonth =
    //     today + (objToday.getDate() < 10)
    //       ? "0" + objToday.getDate() + domEnder
    //       : objToday.getDate() + domEnder,
    //   months = new Array(
    //     "January",
    //     "February",
    //     "March",
    //     "April",
    //     "May",
    //     "June",
    //     "July",
    //     "August",
    //     "September",
    //     "October",
    //     "November",
    //     "December"
    //   ),
    //   curMonth = months[objToday.getMonth()],
    //   curYear = objToday.getFullYear(),
    //   curHour =
    //     objToday.getHours() > 12
    //       ? objToday.getHours() - 12
    //       : objToday.getHours() < 10
    //       ? "0" + objToday.getHours()
    //       : objToday.getHours(),
    //   curMinute =
    //     objToday.getMinutes() < 10
    //       ? "0" + objToday.getMinutes()
    //       : objToday.getMinutes(),
    //   curSeconds =
    //     objToday.getSeconds() < 10
    //       ? "0" + objToday.getSeconds()
    //       : objToday.getSeconds(),
    //   curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";
    // const today =
    //   dayOfMonth +
    //   " of " +
    //   curMonth +
    //   ", " +
    //   curYear +
    //   " " +
    //   dayOfWeek +
    //   " " +
    //   curHour +
    //   ":" +
    //   curMinute +
    //   "." +
    //   curSeconds +
    //   " " +
    //   curMeridiem;
    return (
      <>
        {data && data.outletRegister ? (
          <div className="custom-print-outer-layout">
            <Row>
              <Col span={12}>{today ? today : "00/00/00"}</Col>

              <Col pull={1} span={12}>
                <IntlMessages id="sell.openclose.printhead" />
              </Col>
            </Row>

            <div className="custom-print-inner-layout">
              <Row>
                <Col span={24}>
                  <h1>
                    <strong>
                      <IntlMessages id="sell.openclose.printsubhead" />
                    </strong>
                  </h1>
                </Col>
              </Row>

              <Row style={{ marginTop: "10px" }}>
                <Col span={24}>
                  <h3>
                    <strong>
                      <IntlMessages id="sell.openclose.printCurruser" />
                    </strong>
                  </h3>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <h3>{data.currUserName ? data.currUserName : "---"}</h3>
                </Col>
              </Row>

              <Row style={{ marginTop: "15px" }}>
                <Col span={6}>
                  <h2>
                    <strong>
                      <IntlMessages id="sell.openclose.regdetail1" />
                    </strong>
                  </h2>
                </Col>
                <Col pull={1} span={8}>
                  <h2>{data.outletName ? data.outletName : "---"}</h2>
                </Col>
              </Row>

              <Row>
                <Col span={6}>
                  <h2>
                    <strong>
                      <IntlMessages id="sell.openclose.regdetail2" />
                    </strong>
                  </h2>
                </Col>
                <Col pull={1} span={8}>
                  <h2>
                    {data.outletRegister && data.outletRegister.registerName
                      ? data.outletRegister.registerName
                      : "---"}
                  </h2>
                </Col>
              </Row>

              <Row>
                <Col span={6}>
                  <h2>
                    <strong>
                      <IntlMessages id="sell.openclose.regdetail3" />
                    </strong>
                  </h2>
                </Col>
                <Col pull={1} span={6}>
                  <h2>
                    {data.outletRegister && data.outletRegister.closure
                      ? data.outletRegister.closure
                      : "---"}
                  </h2>
                </Col>
              </Row>

              <Row>
                <Col span={6}>
                  <h2>
                    <strong>
                      <IntlMessages id="sell.openclose.regdetail4" />
                    </strong>
                  </h2>
                </Col>
                <Col pull={1} span={8}>
                  <h2>
                    {data.outletRegister && data.outletRegister.openedOnDate
                      ? data.outletRegister.openedOnDate
                      : "---"}
                  </h2>
                </Col>
              </Row>

              <Row>
                <Col span={6}>
                  <h2>
                    <strong>
                      <IntlMessages id="sell.openclose.regdetail4closingtime" />
                    </strong>
                  </h2>
                </Col>
                <Col pull={1} span={8}>
                  <h2>
                    {data.outletRegister && data.outletRegister.closedOnDate
                      ? data.outletRegister.closedOnDate
                      : "---"}
                  </h2>
                </Col>
              </Row>

              <Divider
                style={{ marginTop: "10px", backgroundColor: "black" }}
              />

              <Row style={{ marginTop: "15px" }}>
                <Col span={12}>
                  <h3>
                    <strong>
                      {/* <IntlMessages id="sell.openclose.col1" /> */}
                    </strong>
                  </h3>
                </Col>

                <Col span={12}>
                  <Row justify="end">
                    <Col span={7}>
                      <h3>
                        <strong>
                          <IntlMessages id="sell.openclose.col2" />
                        </strong>
                      </h3>
                    </Col>
                    <Col span={7}>
                      <h3>
                        <strong>
                          <IntlMessages id="sell.openclose.col3" />
                        </strong>
                      </h3>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Divider style={{ backgroundColor: "black" }} />

              <Row style={{ marginLeft: "5px" }}>
                <Col span={12}>
                  <h3>
                    <strong>
                      <IntlMessages id="sell.openclose.cash" />
                    </strong>
                  </h3>
                </Col>

                <Col span={12}>
                  <Row justify="end">
                    <Col span={7}>
                      <h3>
                        {`${currData.currencyCode} `}
                        {/* {data.outletRegister && data.outletRegister.expected
                          ? data.outletRegister.expected
                          : "0.00"} */}
                        {totalExpected
                          ? formatDigits(totalExpected, decimal)
                          : "0.00"}
                      </h3>
                    </Col>
                    <Col span={7}>
                      <h3>
                        {`${currData.currencyCode} `}
                        {data.outletRegister && data.outletRegister.counted
                          ? data.outletRegister.counted
                          : "0.00"}
                      </h3>
                    </Col>
                  </Row>
                </Col>

                <Divider style={{ backgroundColor: "black" }} />
              </Row>

              <Row style={{ marginLeft: "10px" }}>
                <Col span={12}>
                  <h3>
                    <strong>
                      <IntlMessages id="sell.openclose.cashmove" />
                    </strong>
                  </h3>
                </Col>
              </Row>

              <Row style={{ marginTop: "10px", marginLeft: "15px" }}>
                <Col span={12}>
                  <h3>
                    <strong>
                      <IntlMessages id="sell.openclose.cashcol2" />
                    </strong>
                  </h3>
                </Col>

                <Col span={12}>
                  <Row justify="end">
                    <Col span={9}>
                      <h3>
                        <strong>
                          <IntlMessages id="sell.openclose.cashcol3" />
                        </strong>
                      </h3>
                    </Col>
                    <Col span={9}>
                      <h3>
                        <strong>
                          <IntlMessages id="sell.openclose.type" />
                        </strong>
                      </h3>
                    </Col>
                  </Row>
                </Col>
                <Divider style={{ backgroundColor: "black" }} />
              </Row>

              {/* loop */}

              {data.registerInOut &&
                data.registerInOut.length > 0 &&
                data.registerInOut.map((e, key) => {
                  // let type = "--";
                  // if(e.reason){
                  //   if(){

                  //   }

                  // }
                  return (
                    <Row key={key} style={{ marginLeft: "15px" }}>
                      <Col span={12}>
                        <h3>{e.user ? e.user : "---"}</h3>
                      </Col>

                      <Col span={12}>
                        <Row justify="end">
                          <Col span={9}>
                            <h3>
                              {`${currData.currencyCode} `}
                              {e.amount ? e.amount : "0.00"}
                            </h3>
                          </Col>
                          <Col span={9}>
                            <h3>
                              {data.registerInOut
                                .filter((a) => a.pid == e.pid)
                                .map((x) => {
                                  return (
                                    <>
                                      {x.reason == "OF" ? (
                                        <>
                                          <IntlMessages id="sell.cashlisting.openingfloat" />
                                        </>
                                      ) : x.reason == "CI" ? (
                                        <>
                                          <IntlMessages id="sell.cashlisting.cashin" />
                                        </>
                                      ) : x.reason == "CO" ? (
                                        <>
                                          <IntlMessages id="sell.cashlisting.cashout" />
                                        </>
                                      ) : x.reason == "PCI" ? (
                                        <>
                                          <IntlMessages id="sell.cashlisting.pettycashin" />
                                        </>
                                      ) : x.reason == "PCO" ? (
                                        <>
                                          <IntlMessages id="sell.cashlisting.pettycashout" />
                                        </>
                                      ) : (
                                        <>{"--"}</>
                                      )}
                                    </>
                                  );
                                })}
                            </h3>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  );
                })}
              <Row style={{ marginLeft: "15px" }}>
                <Divider style={{ backgroundColor: "black" }} />
              </Row>

              <Row style={{ marginLeft: "10px" }}>
                <Col span={12}>
                  <h3>
                    <IntlMessages id="sell.openclose.closingfloat" />
                  </h3>
                </Col>
                <Col span={12}>
                  <Row justify="end">
                    <Col span={9}>
                      <h3>
                        {`${currData.currencyCode} `}
                        {data.registerInOut &&
                          data.registerInOut.filter((a) => a.cashManageID != "")
                            .length > 0 &&
                          data.registerInOut.filter(
                            (a) => a.cashManageID != ""
                          )[0].closingFloat}
                      </h3>
                    </Col>
                    <Col span={9}></Col>
                  </Row>
                </Col>
              </Row>

              {cashToBank && cashToBank.includes("-") && (
                <Row style={{ marginLeft: "10px" }}>
                  <Col span={12}>
                    <h3>
                      <strong>
                        <IntlMessages id="sell.openclose.closingfloatinminus" />
                      </strong>
                    </h3>
                  </Col>
                  <Col span={12}>
                    <Row justify="end">
                      <Col span={7}></Col>
                      <Col span={7}>
                        <h3>
                          {`${currData.currencyCode} `}
                          {cashToBank}
                        </h3>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )}

              <Row style={{ marginLeft: "10px" }}>
                <Col span={12}>
                  <h3>
                    <strong>
                      <IntlMessages id="sell.openclose.cashtobank" />
                    </strong>
                  </h3>
                </Col>
                <Col span={12}>
                  <Row justify="end">
                    <Col span={7}></Col>
                    <Col span={7}>
                      <h3>
                        {cashToBank && !cashToBank.includes("-") ? (
                          <strong>
                            {`${currData.currencyCode} `}

                            {cashToBank}
                          </strong>
                        ) : (
                          <strong>
                            {`${currData.currencyCode} `}
                            {"0.00"}
                          </strong>
                        )}
                      </h3>
                    </Col>
                  </Row>
                </Col>
                <Divider style={{ backgroundColor: "black" }} />
              </Row>

              <Row>
                <Col span={12}>
                  <h1>
                    <strong>
                      <IntlMessages id="sell.openclose.total" />
                    </strong>
                  </h1>
                </Col>

                <Col span={12}>
                  <Row justify="end">
                    <Col span={7}>
                      <h2>
                        <strong>
                          {`${currData.currencyCode} `}
                          {totalExpected
                            ? formatDigits(totalExpected, decimal)
                            : "0.00"}
                          {/* {data.outletRegister && data.outletRegister.expected
                            ? data.outletRegister.expected
                            : "0.00"} */}
                        </strong>
                      </h2>
                    </Col>
                    <Col span={7}>
                      <h2>
                        <strong>
                          {`${currData.currencyCode} `}
                          {data.outletRegister && data.outletRegister.counted
                            ? data.outletRegister.counted
                            : "0.00"}
                        </strong>
                      </h2>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        ) : (
          <h1>
            <IntlMessages id="sell.openclose.connectionlost" />
          </h1>
          // <table>
          //   <thead>
          //     <th>column 1</th>
          //     <th>column 2</th>
          //     <th>column 3</th>
          //   </thead>
          //   <tbody>
          //     <tr>
          //       <td>data 1</td>
          //       <td>data 2</td>
          //       <td>data 3</td>
          //     </tr>
          //   </tbody>
          // </table>
        )}
      </>
    );
  }
}

// import React, { memo, pure } from "react";
// import {
//   Button,
//   Divider,
//   Row,
//   Col,
//   message,
//   Form,
//   Spin,
//   Table,
//   Avatar,
// } from "antd";
// // import IntlMessages from "../../../util/IntlMessages";
// import { useHistory } from "react-router-dom";
// import { useDispatch, useStore, useSelector } from "react-redux";

// const PrintSummary = (props) => {
//   const cashManageID = props.cashManageID;
//   const history = useHistory();
//   const store = useStore();
//   const [form] = Form.useForm();
//   const dispatch = useDispatch();

//   return (
//     <table>
//       <thead>
//         <th>column 1</th>
//         <th>column 2</th>
//         <th>column 3</th>
//       </thead>
//       <tbody>
//         <tr>
//           <td>data 1</td>
//           <td>data 2</td>
//           <td>data 3</td>
//         </tr>
//       </tbody>
//     </table>
//   );
// };

// export default memo(PrintSummary);
